import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  AlertController,
  ToastController
} from "ionic-angular";
import { DatabaseProvider } from "../../providers/database/database";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/mergeMap";
import { AuthProvider } from "../../providers/auth/auth";
import { HomePage } from "../home/home";

@IonicPage()
@Component({
  selector: "page-admin-clinic-switch",
  templateUrl: "admin-clinic-switch.html"
})
export class AdminClinicSwitchPage {

  user: any;
  public clinicList: Observable<any[]>;
  clinic_name: string;
  clinic_id: string;

  filteredclinics: any[];
  clinics: any[];

  searchTerm: string;
  allclinics;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private readonly auth: AuthProvider,
    public database: DatabaseProvider,
    public alertCtrl: AlertController,
    public toastCtrl: ToastController
  ) {
    this.auth.getCurrentUser().then(user => {
      this.user = user;
      this.clinic_name = user.clinic_name;
      this.clinic_id = user.clinic_id;

      this.database
      .getClinics()
      .snapshotChanges()
      .map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as any;
          data.id = a.payload.doc.id;
          return data;
        });
      }).subscribe((clinics) => {
        this.allclinics = clinics;
        this.clinics = clinics;
      });
    });
  }


  switchClinic(selected_clinic)  {
    console.log(selected_clinic)
    let confirm = this.alertCtrl.create({
      title: "Switch Clinic?",
      message: "Are you sure you want to switch to viewing " + selected_clinic.clinic_name + "?",
      buttons: [
        {
          text: "No",
          handler: () => {
            console.log("Don't switch clinic right now");
          }
        },
        {
          text: "Yes",
          handler: () => {
            let clinic: any = {};
            clinic.clinic_id = selected_clinic.id;
            clinic.clinic_name = selected_clinic.clinic_name;
            console.log("User ID: ", this.user.id);
            console.log("New Clinic: ", clinic);
     
            this.database.updateUser(this.user.id, clinic).then((data) => {
              console.log("Update User Complete: ", data);
              this.navCtrl.setRoot(HomePage);
            })
            .catch((err) => {
              console.log(err)
            })
   
          }
        }
      ]
    });
    confirm.present();
  }

  filterItems(searchTerm) {
    return this.clinics.filter(clinic => {
      return (
        clinic.clinic_name.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1
      );
    });
  }

  setFilteredItems() {
    this.clinics = this.allclinics;
    this.clinics = this.filterItems(this.searchTerm);
  }

  resetClinics(val) {
    this.clinics = this.allclinics
  }
}



// WEBPACK FOOTER //
// ./src/pages/admin-clinic-switch/admin-clinic-switch.ts